import { Component } from "react";
import { debounce } from "lodash-es";
import { isProduction } from "@claroty/utilities/infra/environmentUtils";
import { FullstoryMount } from "@claroty/utilities/tracking/fullStoryUtils";
import { initTracking } from "@claroty/utilities/tracking/trackingCore";
import autoBind from "auto-bind";
import { sendReduxAnalyticsEvent } from "~/store/analytics/analyticsHandler";
import { onPageView } from "../../utils/tracking";
import { isAnalyticsDisabled } from "../../utils/tracking/isAnalyticsDisabled";
import { sendSplunkError, sendSplunkEvent } from "../../utils/tracking/splunk";

// TODO Move this logic to utils/tracking
class AppAnalyticsHelper extends Component {
    constructor(props) {
        super(props);

        autoBind(this);
        this.sendViewportSize = debounce(this.sendViewportSize, 1000);
        this.lastPageTitle = undefined;
    }

    componentDidMount() {
        // Make FullStory not use inline scripts to support more strict CSP
        window.addEventListener("resize", this.sendViewportSize);

        this.sendViewportSize();
        this.sendScreenSize();

        onPageView();
        initTracking({
            sendSplunkError,
            sendSplunkEvent,
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.sendViewportSize);
    }

    lastPageTitle: string;

    isAnalyticsDisabled() {
        return !isProduction || isAnalyticsDisabled();
    }

    sendGlobalEvent(event, params) {
        if (this.isAnalyticsDisabled()) {
            return;
        }

        sendReduxAnalyticsEvent({ action: event, ...params });
    }

    sendScreenSize() {
        const screenSize = `${window.screen.width}x${window.screen.height}`;
        const screenAvailSize = `${window.screen.availWidth}x${window.screen.availHeight}`;

        this.sendGlobalEvent("Screen Size", {
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            screenSize: screenSize,

            screenAvailWidth: window.screen.availWidth,
            screenAvailHeight: window.screen.availHeight,
            screenAvailSize: screenAvailSize,
        });
    }

    sendViewportSize() {
        this.sendGlobalEvent("Window Resize", {
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
            viewportSize: `${window.innerWidth}x${window.innerHeight}`,
        });
    }

    render() {
        if (this.isAnalyticsDisabled()) {
            return null;
        }

        return <FullstoryMount />;
    }
}

export default AppAnalyticsHelper;
